module.exports = __webpack_public_path__ + "static/joey-8d9462c7e313c7f957425882286d678f.jpg";